<template>
  <div
    :class="[wrapperClass ? wrapperClass : 'd-inline-flex']"
  >
    <Component
      :is="icon"
      :width="width"
      :color="color || accentColor"
    />

    <p
      v-if="text"
      class="font-weight-light text-center mt-4"
    >
      {{ text }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LmNoDataIcon from '@/svg/icons/LmNoDataIcon'
import LmSettingsIcon from '@/svg/icons/LmSettingsIcon'
import LmNoNotifyIcon from '@/svg/icons/LmNoNotifyIcon'
import LmDashboardIcon from '@/svg/icons/LmDashboardIcon'
import LmInboxIcon from '@/svg/icons/LmInboxIcon'
import LmAccessDeniedIcon from '@/svg/icons/LmAccessDeniedIcon'
import LmErrorIcon from '@/svg/icons/LmErrorIcon'
import LmEditableIcon from '@/svg/icons/LmEditableIcon'

export default {
  components: {
    LmNoDataIcon,
    LmSettingsIcon,
    LmNoNotifyIcon,
    LmDashboardIcon,
    LmInboxIcon,
    LmAccessDeniedIcon,
    LmErrorIcon,
    LmEditableIcon
  },
  props: {
    icon: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '7.5em'
    },
    wrapperClass: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('settings', ['accentColor'])
  }
}
</script>
